import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ShieldAlert } from "lucide-react";

// Confidence bands for inferred supply-chain edges.
export const confidenceBand = (c) =>
  c >= 0.75 ? "high" : c >= 0.5 ? "medium" : "low";

const BAND_STYLES = {
  high: "bg-emerald-100 text-emerald-700 border-emerald-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-red-100 text-red-700 border-red-200",
};

const VIA_LABEL = {
  fixture: "Verified contract",
  sayari_mock: "Trade-network graph (simulated)",
  panjiva_mock: "Trade-data feed (simulated)",
  user_input: "Manual entry",
  inference: "Inferred",
};

// Shows the edge confidence + inferred_via source. Low-confidence edges get a
// prominent warning tooltip so reviewers know the link is uncertain.
export const ConfidenceBadge = ({ confidence, inferredVia }) => {
  const band = confidenceBand(confidence);
  const via = VIA_LABEL[inferredVia] || inferredVia || "unknown";
  const pct = Math.round(confidence * 100);

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={`confidence-badge-${band}`}
            data-band={band}
            className={`inline-flex cursor-default items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${BAND_STYLES[band]}`}
          >
            {band === "low" && <ShieldAlert size={11} />}
            {pct}%
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[220px]" data-testid="confidence-tooltip">
          <p className="text-xs font-semibold capitalize">{band} confidence link</p>
          <p className="mt-0.5 text-xs text-white/70">
            Inferred via <span className="font-medium">{via}</span> · {pct}% confidence
          </p>
          {band === "low" && (
            <p className="mt-1 text-[11px] text-amber-300">
              Low-confidence — verify before acting on this relationship.
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
